export default __webpack_public_path__ + "static/media/banner-mb.2418d5d2.webp";